module.exports = __webpack_public_path__ + "assets/6090fd2017fd38feb7a3c2e572a00f05.png";